module.exports = __webpack_public_path__ + "static/img/buy_ask@3x.cc5f227.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/buy_ask@3x.png
// module id = OM0w
// module chunks = 1